<template>
    <div :class="['story-card', col]" :style="`background-image: url('${background}')`">
        <div class="story-card__inner flex between">
            <div class="story-card__col sm-12 story-card__col-left">
                <div class="">
                    <div class="blockquoteIco">
                        <svg width="37" height="30" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M33.2864 0.231999C33.5289 0.0620063 33.8186 -0.0183904 34.1096 0.00353838C34.4007 0.0254671 34.6764 0.148472 34.8931 0.353066L35.7681 1.50558C35.9088 1.79904 35.9437 2.13578 35.8664 2.45401C35.7891 2.77223 35.6048 3.05059 35.3474 3.23799C33.7707 4.61004 32.6245 5.66974 31.9086 6.4171C30.6355 7.77467 29.5815 9.33982 28.7877 11.0514C28.6316 11.4037 29.0304 11.6276 29.2385 11.6991C34.4084 13.4747 36.9938 16.6029 36.9946 21.0839C37.0366 22.2819 36.8344 23.4756 36.4013 24.5854C35.9681 25.6951 35.3141 26.6954 34.4828 27.5196C32.7784 29.1831 30.5151 30.073 28.1866 29.9953C27.024 29.9677 25.8827 29.6637 24.8488 29.1063C23.8149 28.5488 22.9155 27.7525 22.2187 26.7775C20.6174 25.0012 19.7101 22.6609 19.6757 20.2183C19.6773 13.325 24.2142 6.66286 33.2864 0.231999ZM13.6107 0.232C13.8532 0.062008 14.1429 -0.0183887 14.4339 0.0035401C14.7249 0.0254689 15.0007 0.148474 15.2174 0.353067L16.0924 1.50558C16.2331 1.79905 16.268 2.13579 16.1907 2.45401C16.1134 2.77223 15.9291 3.05059 15.6717 3.238C14.095 4.61004 12.9488 5.66974 12.2329 6.4171C10.9599 7.77473 9.90587 9.33986 9.11196 11.0514C8.95591 11.4037 9.35469 11.6276 9.56276 11.6991C14.7327 13.4747 17.3181 16.6029 17.3188 21.0839C17.3609 22.2819 17.1587 23.4756 16.7256 24.5854C16.2924 25.6951 15.6384 26.6954 14.8071 27.5196C13.1027 29.1829 10.8394 30.0729 8.51089 29.9953C7.34834 29.9677 6.20697 29.6637 5.17308 29.1063C4.1392 28.5488 3.23984 27.7525 2.54299 26.7775C0.941722 25.0012 0.034366 22.6609 2.95955e-06 20.2183C0.00154349 13.325 4.53845 6.66286 13.6107 0.232Z"
                                fill="#6367A7"/>
                        </svg>
                    </div>
                    <div class="story-card__title">{{ title }}</div>
                    <div class="story-card__description">{{ description }}</div>
                </div>
            </div>
            <div class="story-card__col sm-12 story-card__col-right">
                <div class="cardInfo" v-if="card">
                    <div class="cardInfo__name">{{ card.name }}</div>
                    <div class="cardInfo__position" v-if="card.position">{{ card.position[0] }}</div>
                    <div class="cardInfo__previousCoop">{{translates.previousCooperation}}</div>
                    <div class="cardInfo__compImg"><img :src="card.companyLogo" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// reference https://i.imgur.com/1lkcCkE.png
import {inject} from "vue";

export default {
    name: 'StoryCard',
    inheritAttrs: false,
    props: {
        title: String,
        description: String,
        background: String,
        card: {
            type: Object,
            default: {}
        },
        col: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {
        const translates = inject('translates', {})
        return {translates}
    },
}
</script>

<style lang="scss" scoped>
.story-card {
    background-size: cover;

    &__inner {
        padding: 58px 74px 100px;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
        border-radius: var(--br-1);
        overflow: hidden;
        height: 100%;


        @include tablet {
            flex-direction: column;
            padding: 38px 32px;
        }
        @include mobile {
            padding: 24px;
            > .flex {
                flex-wrap: wrap;
            }
        }
    }


    &__col {
        flex: 1;

        &-right {
            position: relative;
        }
    }


    &__title {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 34px;

        @include mobile {
            font-size: 16px;
            line-height: 24px;
        }
    }

    &__description {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 30px;
    }
}

.blockquoteIco {
    margin-bottom: 34px;
}

.cardInfo {
    position: absolute;
    background-color: #fff;
    padding: 25px;
    border-radius: 6px;
    bottom: -55px;
    left: 15px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);

    @include desktopSm {
        bottom: unset;
        top: 0;
    }

    @include tablet {
        position: relative;
        left: 0;
    }

    &__name {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: var(--c-primary-200);
    }

    &__position {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }

    &__previousCoop {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: var(--c-gray-500);
        margin-bottom: 10px;
    }

    &__compImg {
        display: flex;
        justify-content: flex-start;

        img {
            max-height: 55px;
            object-fit: contain;
        }
    }
}
</style>
